var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import clsx from 'clsx';
import { useClasses, useLayoutProps, useProps, } from '@hawkins/helpers';
import { useFormFieldContainerStyles } from './formFieldContainer.styles';
var displayName = 'FormFieldContainer';
/**
 * A form field container primitive. Used in Hawkins such as `<Input>`.
 */
export var FormFieldContainer = React.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var children = _a.children, props = __rest(_a, ["children"]);
    // Props
    var _e = useProps(displayName, props), className = _e.className, classesProp = _e.classes, _f = _e.component, Component = _f === void 0 ? 'div' : _f, description = _e.description, descriptionProps = _e.descriptionProps, validationMessage = _e.validationMessage, validationMessageProps = _e.validationMessageProps, validationStatus = _e.validationStatus, _g = _e.fullWidth, fullWidth = _g === void 0 ? false : _g, label = _e.label, labelEndAdornment = _e.labelEndAdornment, labelProps = _e.labelProps, layout = _e.layout, _h = _e.requirementColor, requirementColor = _h === void 0 ? 'default' : _h, requirementType = _e.requirementType, styleProp = _e.style, _j = _e.compact, compact = _j === void 0 ? false : _j, rest = __rest(_e, ["className", "classes", "component", "description", "descriptionProps", "validationMessage", "validationMessageProps", "validationStatus", "fullWidth", "label", "labelEndAdornment", "labelProps", "layout", "requirementColor", "requirementType", "style", "compact"]);
    var hasAsterisk = requirementType === 'required-star';
    // State
    var hasValidationMessage = !!validationMessage;
    // Styles
    var baseClasses = useFormFieldContainerStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var containerClassName = clsx(classes.HAWKINS_BASE, classes.root, className, (_b = {},
        _b[classes.compact] = compact,
        _b[classes.fullWidth] = fullWidth,
        _b));
    var style = useLayoutProps({ layout: layout, style: styleProp });
    var labelTextClassName = clsx((_c = {
            'Hawkins-label': true
        },
        _c[classes.labelAdornment] = !!requirementType,
        _c[classes.optionalAdornment] = requirementType === 'optional',
        _c[classes.requiredAdornment] = requirementType === 'required',
        _c[classes.requiredStarAdornment] = hasAsterisk,
        _c[classes.requiredStarAdornmentMonochrome] = hasAsterisk && requirementColor === 'monochrome',
        _c));
    var validationMessageClassName = clsx(classes.validationMessage, (_d = {},
        _d[classes.errorMessage] = validationStatus === 'error' || (hasValidationMessage && !validationStatus),
        _d[classes.successMessage] = validationStatus === 'success',
        _d[classes.warningMessage] = validationStatus === 'warning',
        _d));
    return (_jsxs(Component, __assign({ className: containerClassName, ref: ref, style: style }, rest, { children: [(label || description) && (_jsx("div", __assign({ className: classes.labelContainer }, { children: _jsxs("label", __assign({ className: classes.label }, labelProps, { children: [_jsxs("span", __assign({ className: classes.labelWithAdornmentContainer }, { children: [_jsx("span", __assign({ className: labelTextClassName }, { children: label })), labelEndAdornment] })), description && (_jsx("span", __assign({ className: classes.description }, descriptionProps, { children: description })))] })) }))), children, hasValidationMessage && (_jsx("div", __assign({ className: validationMessageClassName }, validationMessageProps, { children: validationMessage })))] })));
});
FormFieldContainer.displayName = displayName;
